(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-seo-columns"] && !Shopify.designMode) return;
  try {
    function updateCollectionSeoToggle(root) {
    const content = root.querySelector('[data-collection-seo-content]');
    const toggle = root.querySelector('[data-collection-seo-toggle]');
    if (!content || !toggle) return;

    root.classList.remove('is-collapsible', 'is-expanded');
    toggle.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');

    requestAnimationFrame(() => {
      const lineHeight = Number.parseFloat(getComputedStyle(content).lineHeight) || 26;
      const lines = Number.parseInt(getComputedStyle(root).getPropertyValue('--seo-collapsed-lines'), 10) || 3;
      if (content.scrollHeight > lineHeight * lines + 2) {
        root.classList.add('is-collapsible');
        toggle.hidden = false;
      }
    });
  }

  function initCollectionSeoDescriptions(container) {
    container.querySelectorAll('[data-collection-seo-description]').forEach((root) => {
      const toggle = root.querySelector('[data-collection-seo-toggle]');
      if (!toggle || toggle.dataset.initialized === 'true') return;

      toggle.dataset.initialized = 'true';
      toggle.addEventListener('click', () => {
        const expanded = root.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        const label = expanded ? toggle.dataset.readLess : toggle.dataset.readMore;
        const labelElement = toggle.querySelector('[data-collection-seo-toggle-label]');
        if (labelElement) labelElement.textContent = label;
      });

      updateCollectionSeoToggle(root);
      document.fonts?.ready.then(() => updateCollectionSeoToggle(root));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectionSeoDescriptions(document), { once: true });
  } else {
    initCollectionSeoDescriptions(document);
  }
  document.addEventListener('shopify:section:load', (event) => initCollectionSeoDescriptions(event.target));
  } catch(e) { console.error(e); }
})();

})();
